import {NgModule} from '@angular/core';
import {SharedModule} from '../../app-common/shared.module';
import {blogRoutingComponents, BlogRoutingModule} from './blog-routing.module';
import {BlogListArticleComponent} from './components/blog-list-article/blog-list-article.component';
import {BlogPostComponent} from './components/blog-post/blog-post.component';
import {BlogTaxonomyBoxComponent} from './components/blog-taxonomy-box/blog-taxonomy-box.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatInputModule} from '@angular/material/input';
import {BlogUrlResolverService} from './services/blog-url-resolver.service';
import {BlogPostUrlResolverService} from './services/blog-post-url-resolver.service';
import {AdcampaignService} from '../../services/adcampaign.service';
import {SharedCmsModule} from '../../app-common/shared-cms.module';
import {UiIconComponent} from '../../components/ui/ui-icon/ui-icon.component';
import {UiButtonComponent} from '../../components/ui/ui-button/ui-button.component';

@NgModule({
  declarations: [blogRoutingComponents, BlogListArticleComponent, BlogTaxonomyBoxComponent, BlogPostComponent],
  imports: [
    SharedModule,
    BlogRoutingModule,
    SharedCmsModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatInputModule,
    // ListedWidgetModule,
    UiIconComponent,
    UiButtonComponent,
  ],
  providers: [BlogUrlResolverService, BlogPostUrlResolverService, AdcampaignService],
  exports: [],
})
export class BlogModule {}
